export default __webpack_public_path__ + "static/media/RobotoMono-Light.8aedfdaf.woff";